export function getOrgIssuer(issuer: string): string {
  const normalizedIssuer = issuer.replace(/\/$/, '')
  const oauthSegment = '/oauth2/'
  const oauthIndex = normalizedIssuer.indexOf(oauthSegment)

  if (oauthIndex === -1) {
    return normalizedIssuer
  }

  return normalizedIssuer.slice(0, oauthIndex)
}
